import qs from "qs";
import axios from "axios";
import { URL } from "../../../../constants/Constants";

/**
 * Obtiene lista de problemas y soluciones
 * @param {string} mo - Manufacturing Order
 * @param {string} type - Tipo de consulta
 * @param {string} team - Equipo
 * @param {string} list - Lista
 * @returns {Promise<Array|false>} Lista de problemas y soluciones o false si hay error
 */
export const getListProblemSolution = async (mo, type, team, list) => {
  const queryData = {
    code: mo,
    query_type: parseInt(type),
    team: team,
    list: list,
  };

  try {
    const response = await axios.post(URL, qs.stringify(queryData));

    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};
